/*
 * Copyright (C) 2026 Nex4Nova (Geoblast group)
 * SPDX-License-Identifier: Proprietary
 */
import { useLanguage } from '../../contexts/LanguageContext.jsx';
import './LanguageSwitcher.css';

const LANGS = [
  { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
  { code: 'pt', label: 'PT', flag: '🇵🇹', name: 'Português' },
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
];

function LanguageSwitcher() {
  const { lang, setLang, t } = useLanguage();

  return (
    <div className="lang-switcher"       role="group" aria-label={t('language.label')}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`lang-switcher-btn${lang === l.code ? ' active' : ''}`}
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          title={l.name}
        >
          <span className="lang-flag" aria-hidden="true">{l.flag}</span>
          <span className="lang-label">{l.label}</span>
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
